import { cn } from '@/lib/css-utils'
import { satisfactionOptions } from '@/modules/surveys/configs/onboarding/benefits-config'

type SatisfactionColor = typeof satisfactionOptions[number]['color']

function getClassNames(color?: SatisfactionColor | undefined) {
  return cn('rounded-xl px-2 py-0.5 font-medium ',
    {
      'text-green-40 bg-green-40/15': color === 'green-40',
      'text-green-50 bg-green-50/15': color === 'green-50',
      'text-red-40 bg-red-40/15': color === 'red-40',
      'text-yellow-40 bg-yellow-40/15': color === 'yellow-40',
      'text-copy-access bg-copy-accent/15': color === undefined
    }
  )
}

export function SatisfactionBadge({
  compSatisfaction,
}: {
  compSatisfaction: string
}) {
  const option = satisfactionOptions.find(
    (option) => option.id === compSatisfaction,
  )
  const color = option?.color
  return <span className={getClassNames(color)}>{option?.label}</span>
}
